import styled from "styled-components";
import { useEffect, useState } from "react";
import { Card, BlockButton, Alert } from "fiver-react-ui-components";
import axios from "axios";
import { useTranslations } from "hooks";

const StyledWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 90%;

  @media (min-width: ${(props) => props.theme.screenWidthMd}) {
    width: 500px;
  }
`;

const StyledAlert = styled(Alert)`
  margin-bottom: 1rem;
`;

const Wrapper = () => {
  const [ssoUrl, setSsoUrl] = useState("");

  const [translations] = useTranslations();

  useEffect(() => {
    (async () => {
      const res = await axios.get("/sso/sports-alliance/login-url");
      console.log("sso url", res?.data?.url);

      setSsoUrl(res?.data?.url);
    })();
  }, []);

  const handleLoginClicked = () => {
    console.log("handleLoginClicked", ssoUrl);
    window.location.href = ssoUrl;
  };

  return (
    <StyledWrapper>
      <Card>
        <StyledAlert>{translations.ssoAlertText}</StyledAlert>
        <BlockButton onClick={handleLoginClicked}>
          {translations.ssoButtonText}
        </BlockButton>
      </Card>
    </StyledWrapper>
  );
};

export default Wrapper;
